<template>
  <div>
    <div class="pagination">
      <button class="btn-pagination" @click="previousPage" :disabled="currentPage === 1 || currentPage > totalPages">
        <i class="fa-solid fa-chevron-left"></i>
      </button>
      <div class="div-pagination text-center">
        <span v-if="isLoading('loadingLine')">
          <vue-loading type="bubbles" color="#FCA944" :size="{ width: '26px', height: '26px' }"></vue-loading>
        </span>
        <span v-else>
          <div>
            <span class="title title-pagination">
              <span v-if="totalPages == 0">0</span>
              <span v-else>{{ currentPage }}</span> de {{ totalPages }}</span>
          </div>
        </span>
      </div>
      <button class="btn-pagination" @click="nextPage"
        :disabled="currentPage === totalPages || currentPage > totalPages">
        <i class="fa-solid fa-chevron-right"></i>
      </button>
    </div>
  </div>
</template>
<script>

import { mapGetters, mapMutations, mapState } from "vuex";

export default {
  props: {
    totalRecords: Number,
  },
  data() {
    return {
      currentPage: 1,
      totalPerPage: 10 // Substitua pelo número de registros por página desejado
    };
  },
  created() {
    var filter = this.getFilterStorage(this.$route.name);
    if (filter)
      this.currentPage = filter.baseParams.currentPage;
  },
  computed: {
    ...mapState("generic", ["paginations"]),
    ...mapGetters("generic", ["isLoading", "getFilterStorage"]),
    totalPages() {
      return Math.ceil(this.totalRecords / this.paginations.totalPerPage);
    },
    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.paginations.totalPerPage;
      const endIndex = Math.min(startIndex + this.paginations.totalPerPage, this.totalRecords);
      return Array.from({ length: endIndex - startIndex }, (_, index) => index + startIndex + 1);
    }
  },
  methods: {
    ...mapMutations("generic", ["addEvent"]),
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
      this.addEvent({ name: "page-click", data: this.currentPage });
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
      this.addEvent({ name: "page-click", data: this.currentPage });
    }
  }
};
</script>

<style scoped>
.div-pagination {
  width: 100px;
}

.btn-pagination {
  padding: 5px;
  cursor: pointer;
  border: none;
  min-width: 35px;
  border-radius: 30px !important;
  font-size: 13px !important;
  font-weight: 400;
  letter-spacing: 1px !important;
}


.pagination {
  display: flex;
  justify-content: end;
  align-items: center;
  margin-right: 10px;
  margin-bottom: 10px;
}

.pagination-button:hover {
  background-color: #ccc;
}

.pagination-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.title-pagination {
  font-size: 15px;
  font-weight: 400;
}
</style>
